import { MetricsGraphTooltipWrapper } from "./styled";

interface IMetricsGraphTooltipProps {
    date: string;
    value: string;
}

export const MetricsGraphTooltip = ({ date, value }: IMetricsGraphTooltipProps) => {
    return (
        <MetricsGraphTooltipWrapper>
            <span>{date}</span>
            <span>{value}</span>
        </MetricsGraphTooltipWrapper>
    );
};
